import { UseRecordOptions, useRecord } from "./useRecord";

export function useThread(threadId?: string | null, options?: UseRecordOptions) {
  return useRecord("thread", threadId, { name: "useThread", ...options });
}
